import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const HtmlToReactParser = require('html-to-react').Parser;
import { useParams, Link, useNavigate } from 'react-router-dom';
import { ContentHeader, Loader } from '@components';
import { getClientById } from '@app/services/client';
import handleStatus from '../../utils/ajax';
import { logoutUser } from '@app/store/reducers/auth';
import { getAllProjectNames } from '@app/services/project';
import GetTaskFile from '@app/components/getTaskFile/GetTaskFile';
import Comment from '@app/components/comment/Comment';
import { LogTimeTrackingSection } from '@app/components';
import {
  getAllUsers,
  getTaskById,
  getMyProjects,
  updateTask,
  addComment,
  allCommnets,
  updateComment,
  getIssueByTaskId,
  fileRemoveHandler
} from '../../services/tasks';


const ViewClient = (props) => {
  const [attachments, setAttachments] = useState([]);
  const [task, setTask] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([]);
  const [selectedClientProject, setSelectedClientProject] = useState([]);
  const params = useParams();
  const { taskNo, projectId } = params;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInId = useSelector((state: any) => state.auth.currentUser.data._id);
  const taskId = localStorage.getItem('TASKID');
  const htmlToReactParser = new HtmlToReactParser();

  const getAllData = async (id: any, projectId: string) => {
    setShowLoader(true);
    const task = await getTaskById(id, projectId);
    // handleStatus(task.status, () => dispatch(logoutUser()), navigate);
    if (task.data.ok) {

      setTask(task.data.data);
      //   setAssignedTo(
      //     task.data.data.assignedTo.map((val: any) => {
      //       return { value: val._id, label: val.name };
      //     })
      //   );
      //   setDiscription(task.data.data.description);
      //   setFormValues(task.data.data);
      //   setIssueDescription(task.data.data.description);
    }

    const files = await getIssueByTaskId(task.data.data._id);
    // handleStatus(files.status, () => dispatch(logoutUser()), navigate);
    setAttachments(files.data.data);
    const comments = await allCommnets(id, projectId);
    // handleStatus(comments.stauts, () => dispatch(logoutUser()), navigate)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
    if (comments.status === 200) {
      setComments(comments.data.data);
    }
    setShowLoader(false);
  };

  const commentHandler = async () => {
    // console.log('comment handler 74---------', taskNo, comment, '--commnet-----------')
    const resp = await addComment(taskNo, comment);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    if (resp.status === 200) {
      toast.success("Comment added!");
      setComment("");
      getcomments(taskNo,projectId)
    }
  }
  useEffect(() => {


    if (taskId) {
      getAllData(taskNo, projectId);
    }
  }, []);


  const getcomments = async (id: string, projectId: string) => {
    // console.log(id,projectId,'-------------94--------------- task view file')
    const resp = await allCommnets(id, projectId);
    if (resp.status === 200) {
      setComments(resp.data.data);
    }
  }


  if (showLoader) {
    return <Loader title={'Daily'} />;
  }
  // console.log(taskNo, '***************taskNo****', projectId);

  return (
    <div>
      <ContentHeader title="View Tasks" path="/tasks" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All about Clients</h3>
            </div>
            <div className="card-body">
              <div className="">
                <div className="row">
                  <div className="col-md-9">
                    <h3>{task.title}</h3>

                    <div className="mb-3">
                      <h5>Description</h5>
                      <p> {htmlToReactParser.parse(task.description)}</p>
                    </div>

                    <div className="mb-3">
                      <h5>Attachments</h5>
                      <div>
                        <GetTaskFile attachments={attachments} removeHandler={() => { }} mode={"Update"} />
                      </div>
                    </div>

                    <div>
                      <div>
                        <h5 className="my-2"> All Comments</h5>
                        <div>
                          <form className="d-flex flex-column my-2">
                            <textarea
                              style={{ height: '100px', outline: 'blue' }}
                              name="text"
                              onChange={(e) => setComment(e.target.value)}
                              value={comment}
                            />

                            <div>
                              <Button className="my-2" type="button" onClick={commentHandler} variant="primary">
                                Save
                              </Button>
                            </div>
                          </form>
                        </div>
                        <div
                          style={{
                            background: 'white',
                            height: '358px',
                            overflowX: 'hidden',
                            overflowY: 'scroll',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            padding: '10px'
                          }}
                          className="my-2 d-flex flex-column"
                        >
                          {comments.map((comment: any, index) => {
                            let isEditable = false;
                            if (loggedInId === comment.createdBy) {
                              isEditable = true;
                            }

                            return (
                              <Comment
                                key={index}
                                text={comment.text}
                                id={comment._id}
                                isEditable={isEditable}
                                issueId={taskId}
                                getcomments={getcomments}
                                userName={comment.createdBy.name}
                                created_At={comment.created_At}
                              />
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <p>Assigned To: {Object.keys(task).length > 0 && task.assignedTo.map(user => user.name).join(',')}</p>

                    <p>Priority: {task.priority}</p>
                    <p>Issue Type: {task.issueType}</p>

                    <div className="form-group">
                      <label for="status">Status</label>
                      <select value={task.status} className="form-control" id="status">
                        <option value="task">Task</option>
                        <option value="bug">Bug</option>
                        <option value="testing">Testing</option>
                        <option value="r&d">R&D</option>
                      </select>
                    </div>
                    {/* <LogTimeTrackingSection
                      loggedTimeValue={getLoggedTime()}
                      totalTimeValue={getTotalTime()}
                      projectId={formValues.projectId}
                      taskId={formValues._id}
                      onLogTime={() => getAllData(issueId, projectId)}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewClient;
